const createDeleteFileOperationData = (fileName, fileUid) => {
  return {
    type: 'deleteFile',
    fileName: fileName,
    fileId: fileUid,
  }
}

export default createDeleteFileOperationData;